import VerifiedIcon from '@mui/icons-material/Verified';
import {
  Alert,
  Button,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useState } from 'react';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const BusinessStateConnecticut = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Connecticut Business Tax Filing Requirements | TaxZerone"
          description="Understand Connecticut business tax requirements, including applicable returns, deadlines, extensions, penalties, and interest, to meet your state tax obligations."
          keywords=" "
          canonical="business-tax/state-filing/connecticut-tax-filing-requirements/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <BusinessTaxSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/connecticut-business-tax-img.webp" />
                <source srcSet="/assets/images/connecticut-business-tax-img.png" />
                <img
                  src="/assets/images/connecticut-business-tax-img.png"
                  alt="Connecticut Business Tax Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">Connecticut </span>
                </span>{' '}
                Business Tax Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Understand your Connecticut business tax obligations and file
                your state forms accurately with TaxZerone. Learn which taxes
                apply to your business type, how to stay compliant, and what
                forms you need to file with the Connecticut Department of
                Revenue Services (DRS).
              </Typography>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/connecticut-business-tax-img-sm.webp" />
                <source srcSet="/assets/images/connecticut-business-tax-img-sm.png" />
                <img
                  src="/assets/images/connecticut-business-tax-img-sm.png"
                  alt="Connecticut Business Tax Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            What are the Business Tax Forms in Connecticut?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
            Connecticut requires every business operating within the state to
            comply with state tax laws and{' '}
            <Hidden smDown>
              <br />
            </Hidden>{' '}
            file specific tax forms based on its structure—whether you’re a sole
            proprietor, partnership, corporation, or LLC.
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            Here’s a breakdown of the most common filing requirements for each
            business type:
          </Typography>
          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/single-member-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/single-member-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/single-member-icon.png"
                    alt="Sole Proprietorship & Single-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sole Proprietorship & <br /> Single-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2024/income/ct-1040_1224.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-1040
                        </Link>{' '}
                        –
                      </span>{' '}
                      Connecticut Resident Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2024/income/ct-1040nrpy_1224.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-1040NR/PY
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Nonresident or Part-Year Resident Return
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-prior/f1040sc--2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Schedule C
                        </Link>{' '}
                        (Federal Form 1040) -
                      </span>{' '}
                      Profit or Loss from Business (attached to federal return)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/Partnership-income-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/Partnership-income-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/Partnership-income-icon.png"
                    alt="Partnership & Multi-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Partnership & Multi-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2024/pass-through/schedule-ct-k-1_1224.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT K-1
                        </Link>{' '}
                        –
                      </span>{' '}
                      Partner’s or Shareholder’s Share of Income, Deductions,
                      and Credits
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/1-2018/applications/reg10618fillableprotectedpdf.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form REG-1
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Business Tax Registration for Sales, Use, and Withholding
                      Taxes
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/c-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/c-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/c-corporation-icon.png"
                    alt="C Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2024/corp/ct-1120_1224.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-1120
                        </Link>{' '}
                        –
                      </span>
                      Corporation Business Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2024/corp/ct-1120cu_1224.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-1120CU
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Combined Unitary Corporation Business Tax Return (if
                      applicable)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/s-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/s-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/s-corporation-icon.png"
                    alt="S Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2022/pass-through/ct-1065-ct-1120si_1222.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-1065/CT-1120SI
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Business Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2024/pass-through/schedule-ct-k-1_1224.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT K-1
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Shareholder’s Share of Income, Deductions, and Credits
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/business-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/business-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/business-tax-icon.png"
                    alt="Pass-Through Entities"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Pass-Through Entities
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://azdor.gov/sites/default/files/2023-03/FORMS_TPT_2016_10872-f_0201.pdfhttps://portal.ct.gov/-/media/drs/forms/2022/pass-through/ct-1065-ct-1120si_1222.pdf"
                          sx={{ color: '#0202ff' }}
                          target="_blank"
                        >
                          {' '}
                          Form CT-1065/CT-1120SI
                        </Link>{' '}
                        –
                      </span>{' '}
                      Composite Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2024/estate/ct-1041_1224.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-1041
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Fiduciary Income Tax Return (if applicable)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/withholding-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/withholding-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/withholding-tax-icon.png"
                    alt="Tax-Exempt Organizations"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Tax-Exempt Organizations
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2024/unrelated/ct-990t_1224.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-990T
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Connecticut Corporation Business Tax Return for Exempt
                      Organizations (if they have unrelated business income)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/property-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/property-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/property-icon.png"
                    alt="Additional California Business Tax Forms "
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Additional California Business Tax Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2023/withholding/ct-941_1223.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-941
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Withholding Tax Return for Employers
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2022/wth/ct-945_1222.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CT-945
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Annual Withholding Return for Nonpayroll Amounts
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/2022/sut/os-114_0222.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form OS-114
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Sales and Use Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://portal.ct.gov/-/media/drs/forms/1-2018/bet/op-424_0918.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form OP-424
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Business Entity Tax Return (for prior years before repeal
                      in 2020)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column' }}
          sx={{ pt: 2, pb: 2, justifyContent: 'center', mb: 5 }}
        >
          <Grid
            size={12}
            sx={{
              textAlign: { md: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'center', sm: 'center' },
                }}
              >
                What are the deadlines for the Business Tax Forms in
                Connecticut?
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: { lg: 18, md: 16, sm: 14, xs: 14 }, mb: 3 }}
              >
                Understand the key deadlines for filing Connecticut business
                taxes for all entity types:
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }} justifyContent="center">
            <Box
              component="div"
              sx={{
                mb: 2,
                maxWidth: 800,
                justifyContent: 'center',
                alignItems: 'center',
                m: 'auto',
              }}
            >
              <TableContainer
                sx={{ border: '1px solid #828282', borderRadius: 2 }}
              >
                <Table sx={{}} aria-label="Due Date Chart">
                  <TableBody>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        General Partnerships
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: '1px solid #828282',
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Limited Partnerships / LLPs / LLLPs
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: '1px solid #828282',
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Limited Liability Companies (LLCs)
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        S Corporations
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        C Corporations
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of the month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        15<sup>th</sup> day of the month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Tax Exempt Organizations
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 5<sup>th</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        15<sup>th</sup> day of 5<sup>th</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Pass-Through Entities
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        15<sup>th</sup> day of 3<sup>rd</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Sales and Use Tax
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        <ul>
                          <li style={{ marginBottom: 8, fontSize: 16 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Filing frequency:
                            </span>{' '}
                            Monthly or quarterly, as assigned by DRS
                          </li>
                          <li>
                            <span style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              Monthly filers:
                            </span>{' '}
                            Due last day of the month following the reporting
                            period
                          </li>
                        </ul>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          // borderBottom: '1px solid #828282',
                        }}
                      >
                        Withholding Tax
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          // borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        <ul>
                          <li style={{ marginBottom: 8, fontSize: 16 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Quarterly return due dates:
                            </span>{' '}
                            April 30, July 31, October 31, and January 31
                          </li>
                          <li style={{ marginBottom: 0 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Annual reconciliation (Form CT-945):
                            </span>{' '}
                            Due January 31 of the following year
                          </li>
                        </ul>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What Business Extension Forms are required in Connecticut?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 0, fontSize: 20, fontWeight: 600 }}
                >
                  Business Type
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    mb: 3,
                    mr: 2,
                    ml: -3,
                    listStyleType: 'none',
                    '& li': { mb: 1.5 },
                  }}
                >
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Corporations & Unitary Combined Groups{' '}
                      <Link
                        href="https://portal.ct.gov/-/media/drs/forms/2024/corp/ct-1120-ext_1224.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form CT-1120 EXT
                      </Link>
                    </Box>
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Partnerships & S Corporations{' '}
                      <Link
                        href="https://portal.ct.gov/-/media/DRS/Forms/2022/Pass-Through/CT-1065-CT-1120SI-EXT_1222.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Form CT-1065/CT-1120SI EXT{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Trusts & Estates{' '}
                      <Link
                        href="https://portal.ct.gov/-/media/drs/forms/2022/estate/ct-1041-ext_1222.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form CT-1041 EXT{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      All Business Types (if payment time extension needed){' '}
                      <br />
                      <Link
                        href="https://portal.ct.gov/-/media/drs/forms/2022/income/ct-1127_1222.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form CT-1127{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{ fontSize: { md: 22, sm: 18, xs: 16 }, fontWeight: 600 }}
                >
                  Online Payment Option
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Connecticut business tax payments can also be made online
                  through the{' '}
                  <Link
                    href="https://portal.ct.gov/DRS"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    DRS Taxpayer Service Center (TSC)
                  </Link>
                  .
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note: </b> TaxZerone supports{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    filing Form 7004
                  </Link>{' '}
                  for federal business tax extensions and provides guidance for
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Connecticut state extension forms (CT-1120 EXT,
                    CT-1065/1120SI EXT, and CT-1041 EXT)
                  </span>{' '}
                  .
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              {/* <Link href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"> */}
              <Box
              // sx={{
              //   '&:hover': {
              //     transform: 'scale(1.02)',
              //   },
              //   '& .img-responsive:hover': {
              //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              //   },
              //   transition: 'transform 0.3s ease-in-out',
              // }}
              >
                <picture>
                  <source srcSet="/assets/images/connecticut-extension-img.webp" />
                  <source srcSet="/assets/images/connecticut-extension-img.png" />
                  <img
                    src="/assets/images/connecticut-extension-img.png"
                    alt="What are the Business Extension Forms are required in Connecticut?"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                    style={{ borderRadius: 24 }}
                  />
                </picture>
              </Box>
              {/* </Link> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center" mb={3}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                What are the Extended due date for Business Tax
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                Forms in Connecticut?
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, fontSize: 18 }}>
                Understand the key{' '}
                <span style={{ fontWeight: 600 }}> extended deadlines</span> for
                filing Connecticut business taxes for all entity types:
              </Typography>
              <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      General Partnerships
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        6-month
                      </Box>
                      <br />
                      of extension
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Limited Partnerships / LLPs / LLLPs
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        6-month
                      </Box>
                      <br />
                      of extension
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Limited Liability Companies (LLCs)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        6-month
                      </Box>
                      <br />
                      of extension
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      S Corporations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        6-month
                      </Box>
                      <br />
                      of extension
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      C Corporations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        6-month
                      </Box>
                      <br />
                      of extension
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Tax-Exempt Organizations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        6-month
                      </Box>
                      <br />
                      of extension
                    </Typography>
                  </Paper>

                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Pass-Through Entities
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="strong"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        6-month
                      </Box>
                      <br />
                      of extension
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Sales and Use Tax
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      No extension for filing. Returns must be filed by the
                      <br /> regular due dates
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Withholding Tax
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      No filing extension; returns must be filed by standard
                      deadlines
                    </Typography>
                  </Paper>
                </Stack>
              </Box>
              <Alert
                severity="warning"
                icon={false}
                sx={{ mb: 0, mt: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
              >
                <b>Note: </b> If the due date falls on a Saturday, Sunday, or
                legal holiday, the return is considered timely if filed on the
                next business day.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          mb: 5,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container
          maxWidth="xl"
          sx={{
            mb: 5,
            '& .card__content': {
              animation: 'scale linear forwards',
              animationTimeline: 'view()',
              animationRange: '85vh 100vh',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 753, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(210, 186, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Stack
              spacing={2}
              direction={{ md: 'row', xs: 'column' }}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  textAlign: 'left',
                  alignItems: 'left',

                  justifyContent: 'left',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  Connecticut Business Tax Extension Filing Requirements
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  To qualify for a business tax extension in Connecticut, your
                  business must:
                </Typography>
                <Box sx={{ maxWidth: 'auto', textAlign: 'left' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      mr: 2,
                      listStyleType: 'none',
                      '& li': { mb: 2, fontSize: { md: 17, sm: 16, xs: 14 } },
                    }}
                  >
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          File by the original due date
                        </span>{' '}
                        to avoid penalties and interest—extensions apply{' '}
                        <span style={{ fontWeight: 600 }}>only to filing,</span>{' '}
                        not payments.
                      </Box>
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Submit the correct Connecticut extension form
                        </span>{' '}
                        based on ybased on your entity type:
                      </Box>{' '}
                    </li>
                    <ul>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Form CT-1120 EXT
                        </span>{' '}
                        for corporations{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Form CT-1065/CT-1120SI EXT
                        </span>{' '}
                        for partnerships and S-corporations{' '}
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Form CT-1041 EXT
                        </span>{' '}
                        for trusts and estates{' '}
                      </li>
                    </ul>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Estimate and pay any taxes owed
                        </span>{' '}
                        by the original return due date, even if you file for an
                        extension.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Attach a copy of your federal extension (Form 7004)
                        </span>{' '}
                        if applicable—Connecticut generally honors a valid
                        federal extension.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Meet the 6-month extension window,
                        </span>{' '}
                        which typically extends your filing deadline but{' '}
                        <span style={{ fontWeight: 600 }}>
                          not your payment deadline.
                        </span>
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Keep proof of filing and payment confirmations
                        </span>{' '}
                        from the Connecticut Department of Revenue Services
                        (DRS) for compliance.
                      </Box>{' '}
                    </li>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box sx={{}}>
                  <picture>
                    <source
                      srcSet="/assets/images/connecticut-state-img.webp"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <source
                      srcSet="/assets/images/connecticut-state-img.png"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <img
                      src="/assets/images/connecticut-state-img.png"
                      loading="lazy"
                      alt="business tax extension in Connecticut"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                  </picture>
                </Box>
              </Box>
            </Stack>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 753, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(244, 237, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: 'container' }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                <Box
                  component="div"
                  sx={{
                    mb: 3,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                    }}
                  >
                    Connecticut Business Tax Rates
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 3,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 400,
                      textAlign: 'center',
                    }}
                  >
                    Business tax rates vary depending on your entity type:
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    C Corporation{' '}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    7.5%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of net income (Plus a 10% surtax applies to corporations
                    with gross income of $100 million or more or those filing as
                    part of a combined unitary group.)
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    6.99%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of Connecticut-source income (Pass-Through Entity Tax rate)
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    LLCs
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    6.99%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of Connecticut-source income (if subject to Pass-Through
                    Entity Tax).
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Partnerships (LP & LLPs)
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    6.99%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of Connecticut-source income (Pass-Through Entity Tax rate
                    applies if elected or required)
                  </Typography>
                </Paper>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Exempt Organizations
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    Exempt
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    Generally, exempt but may be taxed on{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      unrelated business income
                    </span>
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Estimated Tax Payments for Connecticut Businesses
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 19, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  Businesses in Connecticut must make{' '}
                  <span style={{ fontWeight: 600 }}>
                    estimated tax payments
                  </span>{' '}
                  if they expect to owe{' '}
                  <span style={{ fontWeight: 600 }}>$1,000 or more</span> in{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  state income tax for the year. These prepayments help you
                  avoid underpayment penalties and interest.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Payment Deadlines
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      1<sup>st</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      March 15
                    </Typography>
                    <Typography variant="body1">
                      27% of current year tax OR 30% of last year’s tax
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      2<sup>nd</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      June 15
                    </Typography>
                    <Typography variant="body1">
                      63% of current year tax OR 70% of last year’s tax
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      3<sup>rd</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Sept 15
                    </Typography>
                    <Typography variant="body1">
                      72% of current year tax OR 80% of last year’s tax
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      4<sup>th</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Dec 15
                    </Typography>
                    <Typography variant="body1">
                      90% of current year tax OR 100% of last year’s tax
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Who should pay
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Corporation & Unitary Combined Groups
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.3 } }}>
                      <li>
                        Required to make estimated payments if expected tax
                        liability exceeds{' '}
                        <span style={{ fontWeight: 600 }}> $1,000</span>.{' '}
                      </li>
                      <li>
                        Use{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Form CT-1120 ESA
                        </span>{' '}
                        for estimated corporation business tax payments.{' '}
                      </li>
                    </Box>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Pass-Through Entities (Partnerships, S Corporations, LLCs)
                    </Typography>
                    <Typography variant="body1">
                      If subject to the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Pass-Through Entity Tax (6.99%),
                      </span>{' '}
                      make estimated payments using{' '}
                      <span style={{ fontWeight: 600 }}>
                        Form CT-1065/CT-1120SI ESA.
                      </span>
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Trusts & Estates
                    </Typography>
                    <Typography variant="body1">
                      Trusts & Estates Use{' '}
                      <span style={{ fontWeight: 600 }}>Form CT-1041 ES </span>
                      for estimated fiduciary income tax payments.
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid
              size={12}
              sx={{
                mt: 2,
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box
                component="div"
                sx={{
                  backgroundColor: '#f5efff',
                  borderLeft: '5px solid #45247e',
                  p: 2,
                  mb: 4,
                  borderRadius: 2,
                  textAlign: 'left',
                }}
              >
                <Typography variant="body1" sx={{ fontSize: 14, mt: 0 }}>
                  <span style={{ fontWeight: 600 }}> Missed Payments:</span>{' '}
                  Late or missed estimated payments may result in interest and
                  penalties under Connecticut law.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ pt: 2, mb: 5 }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 0,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Penalties and Interest for Business in Connecticut
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { md: 18, sm: 16, xs: 16 },
                  textAlign: 'center',
                }}
              >
                In Connecticut,{' '}
                <span style={{ fontWeight: 600 }}>interest and penalties</span>{' '}
                apply to any portion of tax not paid by the original due date,
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                {'  '}
                even if an extension to file has been granted.
              </Typography>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 0 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Penalty for late payment or Late filing
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        The penalty for{' '}
                        <span style={{ fontWeight: 600 }}>
                          late payment or underpayment
                        </span>{' '}
                        of tax is{' '}
                        <span style={{ fontWeight: 600 }}>
                          10% of the unpaid tax
                        </span>{' '}
                        not paid by the original due date.
                      </li>
                      <li>A business can avoid this penalty if it: </li>
                      <li>
                        Files{' '}
                        <span style={{ fontWeight: 600 }}>Form CT-1127</span>{' '}
                        (Application for Extension of Time to Pay),{' '}
                      </li>
                      <li>Is granted an extension of time to pay, and </li>
                      <li>
                        Pays the full amount due by the end of the approved
                        extension period.
                      </li>
                      <li>
                        If{' '}
                        <span style={{ fontWeight: 600 }}>
                          no tax is due, a $50 minimum penalty
                        </span>{' '}
                        may apply for filing late.
                      </li>
                    </Box>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Electronic Payment Penalties
                    </Typography>
                    <Typography variant="body1">
                      If your business is required to make electronic payments
                      and fails to do so, the following graduated penalties
                      apply:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ listStyleType: 'disc', mb: 0, '& > li': { mb: 1 } }}
                    >
                      <li>
                        <span style={{ fontWeight: 600 }}>First offense:</span>{' '}
                        10% of the payment amount (up to{' '}
                        <span style={{ fontWeight: 600 }}>$2,500</span>)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>Second offense:</span>{' '}
                        10% of the payment amount (up to{' '}
                        <span style={{ fontWeight: 600 }}>$10,000</span>)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Third and subsequent offenses:
                        </span>{' '}
                        10% penalty, no maximum limit{' '}
                      </li>
                    </Box>
                    <Alert
                      severity="info"
                      icon={false}
                      sx={{ mb: 3, borderLeft: '3px solid #0288d1' }}
                    >
                      <b>Tips:</b> When using online banking, ensure your bank
                      sends an <span style={{ fontWeight: 600 }}>EFT</span>{' '}
                      (Electronic Funds Transfer), not a paper check.
                    </Alert>
                  </Paper>
                </Box>
              </Stack>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 0 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Penalty for Failure to file
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        If the Department of Revenue Services (DRS) files a
                        return on behalf of your business, the penalty is{' '}
                        <span style={{ fontWeight: 600 }}>
                          10% of the balance due or $50,
                        </span>{' '}
                        whichever is greater.
                      </li>
                      <li>
                        If a business is required to file an{' '}
                        <span style={{ fontWeight: 600 }}>amended return</span>
                        (Form CT-PET) and fails to do so, an additional penalty
                        may apply.{' '}
                      </li>
                    </Box>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Penalty for Willful Failure to File or Pay
                    </Typography>
                    <Typography variant="body1">
                      If a business willfully fails to file a return or pay the
                      tax due, it may face:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        A{' '}
                        <span style={{ fontWeight: 600 }}>
                          fine up to $1,000,
                        </span>{' '}
                        or
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Imprisonment up to one year,
                        </span>{' '}
                        or both.
                      </li>
                    </Box>
                  </Paper>
                </Box>
              </Stack>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 2 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Penalty for Willful Filing of a Fraudulent or False Return
                    </Typography>
                    <Typography variant="body1">
                      If a business willfully files a{' '}
                      <span style={{ fontWeight: 600 }}>
                        fraudulent or materially false return,
                      </span>{' '}
                      it may be subject to:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        A{' '}
                        <span style={{ fontWeight: 600 }}>
                          fine up to $5,000,
                        </span>{' '}
                        or
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Imprisonment up to five years,
                        </span>{' '}
                        or both.
                      </li>
                    </Box>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Interest
                    </Typography>
                    <Typography variant="body1">
                      If the business does not pay the tax when due,{' '}
                      <span style={{ fontWeight: 600 }}>
                        interest is charged at 1% per month or a fraction of a
                        month
                      </span>{' '}
                      until the tax is fully paid.
                    </Typography>
                    <Box component="ul" sx={{ mb: 2.4, '& li': { mb: 1.2 } }}>
                      <li>
                        Interest on late or underpaid tax{' '}
                        <span style={{ fontWeight: 600 }}>
                          cannot be waived
                        </span>{' '}
                        under any circumstance.{' '}
                      </li>
                    </Box>
                  </Paper>
                </Box>
              </Stack>
              <Alert
                severity="info"
                icon={false}
                sx={{ mb: 3, borderLeft: '3px solid #0288d1' }}
              >
                <b>Tips:</b> Filing and paying your Connecticut business taxes
                on time through{' '}
                <span style={{ fontWeight: 600 }}> TaxZerone</span> helps you
                stay compliant and avoid costly interest and penalties imposed
                by the{' '}
                <span style={{ fontWeight: 600 }}>
                  Connecticut Department of Revenue Services (DRS)
                </span>
                .
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/state-help-img.webp" />
                  <source srcSet="/assets/images/state-help-img.png" />
                  <img
                    src="/assets/images/state-help-img.png"
                    alt="How TaxZerone can Help You?"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  How TaxZerone can Help You?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  TaxZerone supports{' '}
                  <span style={{ fontWeight: 600 }}>federal tax filing</span>{' '}
                  and also guides you through{' '}
                  <span style={{ fontWeight: 600 }}>
                    Connecticut-state requirements
                  </span>{' '}
                  to help your business stay compliant. While Connecticut
                  business taxes must be filed directly with the{' '}
                  <span style={{ fontWeight: 600 }}>
                    Department of Revenue Services (DRS),
                  </span>
                  TaxZerone provides the guidance you need to:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    Understand which{' '}
                    <span style={{ fontWeight: 600 }}>
                      Connecticut business tax forms
                    </span>{' '}
                    apply to your entity type
                  </li>
                  <li>
                    Know your{' '}
                    <span style={{ fontWeight: 600 }}>
                      state deadlines and payment requirements
                    </span>{' '}
                  </li>
                  <li>
                    Prepare for{' '}
                    <span style={{ fontWeight: 600 }}>
                      extensions and estimated tax payments
                    </span>{' '}
                  </li>
                  <li>
                    Avoid <span style={{ fontWeight: 600 }}>penalties</span> by
                    staying informed and organized{' '}
                  </li>
                </Box>
                <Typography variant="body1">
                  With TaxZerone, you can manage your{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    federal filings easily
                  </span>{' '}
                  while ensuring your{' '}
                  <span style={{ fontWeight: 600 }}>
                    Connecticut state obligations
                  </span>{' '}
                  are met on time and correctly.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          File Smarter, Not Harder!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Simplify your Connecticut and federal business tax filings with
          TaxZerone.
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          Stay compliant, avoid penalties, and file confidently
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=connecticut`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What forms do different business types need to file in
                  Connecticut?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1">
                      In Connecticut, the forms a business needs to file depend
                      on its type. Sole proprietors file{' '}
                      <span style={{ fontWeight: 600 }}>Form CT-1040,</span>{' '}
                      while partnerships, multi-member LLCs, and S corporations
                      file
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Form CT-1065/CT-1120SI
                      </span>{' '}
                      and provide{' '}
                      <span style={{ fontWeight: 600 }}>
                        Schedule CT K-1
                      </span>{' '}
                      to their members or shareholders. C corporations use{' '}
                      <span style={{ fontWeight: 600 }}>Form CT-1120,</span> or{' '}
                      <span style={{ fontWeight: 600 }}>Form CT-1120CU</span> if
                      part of a combined unitary group. Tax-exempt organizations
                      with unrelated business income must file{' '}
                      <span style={{ fontWeight: 600 }}>Form CT-990T</span>.
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Additionally, employers are required to file sales and use
                      tax returns and withholding tax returns separately from
                      their business income filings.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. How do I make a payment for Connecticut business taxes?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 1 }}>
                      Electronic payments can be made through myconneCT at{' '}
                      <Link
                        href="https://portal.ct.gov/DRS-myconneCT"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        portal.ct.gov/DRS-myconneCT.
                      </Link>
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Pay by ACH Debit/Direct Payment:
                        </span>{' '}
                        Using this option authorizes DRS to electronically
                        withdraw a payment from your bank account (checking or
                        savings) on a date you select, up to the due date.{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Pay by Credit Card or Debit Card:
                        </span>{' '}
                        You may elect to pay your tax liability using a credit
                        card (American Express®, Discover®, MasterCard®, Visa®)
                        or a comparable debit card.{' '}
                      </li>
                      <ul>
                        <li>
                          A convenience fee will be charged by the credit card
                          service provider.{' '}
                        </li>
                        <li>
                          You will be informed of the fee amount and may choose
                          to cancel the transaction.{' '}
                        </li>
                        <li>
                          Your payment will be effective on the date the charge
                          is made.{' '}
                        </li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who should file Form CT-1065/CT-1120SI?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 0 }}>
                      Any pass-through entity (partnership, multi-member LLC, S
                      corporation) doing business or with income connected to
                      Connecticut must file this composite income tax return,
                      reporting income and tax credit information for owners.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Does filing a federal extension automatically extend my
                  Connecticut business return?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      Yes. Connecticut generally honors a valid federal
                      extension (
                      <Link
                        href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 7004
                      </Link>
                      ). However, you must file the corresponding{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Connecticut extension form
                      </span>
                      —such as{' '}
                      <span style={{ fontWeight: 600 }}>
                        Form CT-1120 EXT, CT-1065/CT-1120SI EXT, or CT-1041 EXT
                      </span>
                      —and pay any taxes owed by the original due date to avoid
                      penalties and interest.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default BusinessStateConnecticut;
